<template>
  <v-app id="app">
    <router-view />
    <action-message />
    <app-loader />
  </v-app>
</template>

<script>
import ActionMessage from '@/components/ActionMessage';
import AppLoader from '@/components/shared/AppLoader';
import Integration from '@/services/integration';
import { Audit } from '@nsftx/seven-client-sdk-audit';

export default {
  name: 'App',
  components: {
    ActionMessage,
    AppLoader,
  },
  watch: {
    '$route.params.companyId': {
      handler(newVal) {
        if (!newVal) return;

        Audit.init({
          environment: process.env.VUE_APP_AUDIT_ENVIRONMENT,
          tenant: newVal,
          source: '7CMS',
        });
      },
    },
  },
  created() {
    Integration.sendMessage({
      action: 'Slave.Loaded',
      data: {
        message: 'Casino Admin Loaded',
      },
    });

    Integration.subscribe('Router.RouteChanged', (route) => {
      if (!route.data) return;
      const { path } = route.data;

      if (
        !path
        || (path === '/games' && this.$route.name === 'games')
        || (path === '/popular' && this.$route.name === 'popular')
        || (path === '/groups' && this.$route.name === 'groups')
      ) {
        return;
      }

      this.$router.push({ path: route.data.path });
    });
  },
};
</script>

<style lang="scss">
@import "./assets/theme/_clarity";
@import "./assets/external/_icons";

#app {
  background-color: $bg-100;
}
</style>
